import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { AnimatedShimmer } from './CommonShimmer';
import AppTheme from "../../AppTheme";
import AppStyles from '../../AppStyles';
import * as CommonUtils from "../../utils/services/CommonUtils";

export const DashboardShimmer = (props) => {
    return (
        <ScrollView style={{ width: AppTheme.appWidth, marginTop: AppTheme.headerHeight }}>
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={19} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={160} />
            <View style={{ height: 16.1 }} />
            <AnimatedShimmer height={160} />
            <View style={{ height: 18 }} />
            <AnimatedShimmer height={167.2} />
            <View style={{ height: 24 }} />
            <AnimatedShimmer height={370} />
            <View style={{ height: 24 }} />
        </ScrollView>
    )
}

export const PrePurchanseShimmer = (props) => {
    return (
        <ScrollView style={{ width: AppTheme.appWidth }}>
            <AnimatedShimmer height={156} width={AppTheme.appWidth} borderRadius={0} />
            <View style={{ height: 24 }} />
            <AnimatedShimmer height={192} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={98} width={AppTheme.appWidth} borderRadius={0} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={381} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={151} />
            <View style={{ height: 48 }} />
            <AnimatedShimmer height={370} />
        </ScrollView>
    )
}

export const PostPurchaseShimmer = (props) => {
    return (
        <View style={{ width: AppTheme.appWidth }}>
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={150} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={162} />
            <View style={{ height: 24 }} />
            <AnimatedShimmer height={30} />
            <View style={{ height: 48 }} />
            <AnimatedShimmer height={238} width={AppTheme.appWidth} borderRadius={0} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={48} borderRadius={40} />
            <View style={{ height: 16 }} />
        </View>)
}

export const PaymentShimmer = (props) => {
    return (
        <View style={{ width: AppTheme.appWidth }}>
            <AnimatedShimmer height={60} width={AppTheme.appWidth} borderRadius={0} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={44} />
            <View style={{ height: 24 }} />
            <AnimatedShimmer height={301} />
            {/* <View style={styles.safePayment}>
                <Image style={{ padding: 5, marginTop: 3 }} source={{
                    uri: CommonUtils.getImagePath('/images/secure_payment_ic.svg'),
                    width: 12.3, height: 14
                }} width={12} height={12}></Image>
                <Text style={styles.dontWorry}> Don't worry, this payment is completely safe</Text>
            </View> */}
        </View>
    )
}

export const PayWithSubShimmer = (props) => {
    return (
        <View style={{
            width: AppTheme.appWidth,
            alignItems: "center"
        }}>
            <AnimatedShimmer height={224}
                width={AppTheme.appWidth}
                borderRadius={0} />
            <View style={{
                position: 'absolute', top: 65,
                marginHorizontal: 30
            }}>
                <AnimatedShimmer
                    width={AppTheme.appWidth - 60}
                    height={((AppTheme.appWidth - 60) * 0.45)}
                    borderRadius={12} />
                <View style={{ height: 16 }} />
                <AnimatedShimmer
                    width={AppTheme.appWidth - 60}
                    height={60} />
            </View>
            <View style={[AppStyles.bottomFix,
            { padding: 16 }]}>
                <AnimatedShimmer height={40} />
            </View>
        </View>
    )
}

export const PharmacyListingShimmer = (props) => {
    return (
        <View style={{ width: AppTheme.appWidth }}>
            <View style={{ height: 12 }} />
            <AnimatedShimmer height={231} />
            <View style={{ height: 12 }} />
            <AnimatedShimmer height={231} />
            <View style={{ height: 12 }} />
            <AnimatedShimmer height={231} />
            <View style={{ height: 12 }} />
            <AnimatedShimmer height={231} />
        </View>
    )
}

export const SelectedPharmacyShimmer = (props) => {
    return (
        <View style={{ width: AppTheme.appWidth }}>
            <AnimatedShimmer height={82} width={AppTheme.appWidth} borderRadius={0} />
            <View style={{ height: 32 }} />
            <AnimatedShimmer height={45} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={45} />
            <View style={{ backgroundColor: AppTheme.color.grey.divider, marginVertical: 24, height: 1, width: AppTheme.appWidth }} />
            <AnimatedShimmer height={19} />
            <View style={{ height: 16 }} />
            <View style={[AppStyles.flexRowSpaceBetween, { padding: 16 }]}>
                <AnimatedShimmer height={AppTheme.appWidth / 2 + 68} width={AppTheme.appWidth / 2 - 24} />
                <AnimatedShimmer height={AppTheme.appWidth / 2 + 68} width={AppTheme.appWidth / 2 - 24} />
            </View>
            <View style={[AppStyles.flexRowSpaceBetween, { padding: 16 }]}>
                <AnimatedShimmer height={AppTheme.appWidth / 2 + 68} width={AppTheme.appWidth / 2 - 24} />
                <AnimatedShimmer height={AppTheme.appWidth / 2 + 68} width={AppTheme.appWidth / 2 - 24} />
            </View>
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={300} />
        </View>
    )
}

export const OrderListShimmer = (props) => {
    return (
        <View style={{ width: AppTheme.appWidth - 32, marginHorizontal: 16 }}>
            <View style={{ height: 24 }} />
            <AnimatedShimmer height={19} width={AppTheme.appWidth - 32} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={220} width={AppTheme.appWidth - 32} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={220} width={AppTheme.appWidth - 32} />
            <View style={{ height: 16 }} />
            <AnimatedShimmer height={220} width={AppTheme.appWidth - 32} />
        </View>
    )
}

{/* <View>
			<CommonShimmer showShimmer={this.props.showShimmer} width={AppTheme.appWidth} height={130} duration={8000}></CommonShimmer>
		</View>
		<View style={{ marginTop: 16 }}>
			<CommonShimmer showShimmer={this.props.showShimmer} style={{ marginTop: 16 }} width={AppTheme.appWidth - 32} duration={8000} height={60} borderRadius={4}></CommonShimmer>
		</View>
		<View style={{ marginTop: 16 }}>
			<CommonShimmer showShimmer={this.props.showShimmer} width={AppTheme.appWidth - 32} height={75} borderRadius={4} duration={8000}></CommonShimmer>
		</View>
		<View style={{ marginTop: 16 }}>
			<CommonShimmer showShimmer={this.props.showShimmer} width={AppTheme.appWidth - 32} height={150} borderRadius={4} duration={8000}></CommonShimmer>
		</View>
		<View style={AppStyles.mY16} >
			<CommonShimmer showShimmer={this.props.showShimmer} width={AppTheme.appWidth} height={AppTheme.appWidth * 0.35}  duration={8000}></CommonShimmer>
		</View> */}


// export default DashboardShimmer;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    textBottom: {
        fontSize: 14,
        lineHeight: 28
    },
    safePayment: {
        flex: 1,
        marginVertical: 20,
        marginHorizontal: 30,
        justifyContent: 'flex-start',
        flexDirection: 'row',
        alignContent: 'center',
        textAlign: 'center',
    },

    dontWorry: { fontSize: 14, paddingTop: 3, color: AppTheme.color.grey.disable },
}));
